export default __webpack_public_path__ + "static/media/wTop_1_c5.ef8442ce.jpeg";